import { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { CardContainer } from '../../components/CardContainer/CardConteiner'
import MentorCard from '../../components/Cards/MentorCard'
import { Loader } from '../../components/Loader/Loader'
import useOnScreen from '../../hooks/useOnScreen'
import { useScrollToTop } from '../../hooks/useScrollToTop'
import { MentorBase } from '../../types/mentor'
import { useMentors } from './useMentors'

function FavoritesPage() {
  const { slug } = useParams()
  const observerTarget = useRef<HTMLDivElement | null>(null)
  const [currentPage, setCurrentPage] = useState(0)
  const {
    mentors,
    totalPages,
    isLoading,
    removeMentor,
    inDeleteProcess,
    setInDeleteProcess,
    dataIsEmpty,
  } = useMentors(currentPage)
  const needLoadMore = useOnScreen(observerTarget, [!!mentors.length])
  const [isFetching, setIsFetching] = useState(false)
  useScrollToTop()

  // This is a hack to force re-render of MentorCard component
  const [renderCount, setRenderCount] = useState(0)
  const navigate = useNavigate()
  useEffect(() => {
    setRenderCount(prev => prev + 1)
    setIsFetching(false)
  }, [mentors])

  useEffect(() => {
    if (needLoadMore && totalPages > currentPage + 1 && !isFetching) {
      setIsFetching(true)
      setCurrentPage(prev => prev + 1)
    }
  }, [needLoadMore, totalPages])

  useEffect(() => {
    if (slug && mentors.length) {
      if (!mentors.find(m => m.slug === slug)) {
        navigate('/not-found')
      }
    }
  }, [slug, mentors, navigate])

  if (!isLoading && dataIsEmpty) {
    return (
      <div className="flex justify-center items-center h-full fixed top-0 left-0 w-full">
        <div className="flex-col h-[75vh] text-white gap-2 overflow-auto content-center justify-center text-center">
          <div className="text-3xl mb-2">
            You don't have any favorite companions yet.
          </div>
        </div>
      </div>
    )
  }
  return (
    <>
      {isLoading && !mentors?.length && <Loader label="" />}
      <div className="tc-mv-main-container">
        <CardContainer>
          {!!mentors?.length && (
            <>
              {mentors.map((mentor: MentorBase) => (
                <MentorCard
                  key={mentor.mentorId}
                  profile={mentor}
                  renderCount={renderCount}
                  isAuthenticated
                  isFavorite
                  removeMentor={removeMentor}
                  setInDeleteProcess={setInDeleteProcess}
                  isProcessing={inDeleteProcess}
                  inFavorites
                  location="/favorites"
                />
              ))}
              <div
                ref={observerTarget}
                className="pb-8 absolute bottom-0 w-full -z-10"
              />
            </>
          )}
        </CardContainer>
      </div>
    </>
  )
}

export default FavoritesPage
